export default __webpack_public_path__ + "static/media/availability.7dbf21ea.svg";